import React from 'react'

function PointRange() {
  return (
    <ol className="list-group" style={{ margin: "1em" }}>
      <li className="list-group-item">
        <h5>Puan Aralığı</h5>
      </li>

      <li className="list-group-item">
        <input
          type="number"
          id="btncheck1"
          placeholder="Min Puan"
          style={{ textAlign: "center", width: "80%" }}
        />
      </li>
      <li className="list-group-item">
        <input
          type="number"
          id="btncheck2"
          placeholder="Maks Puan"
          style={{ textAlign: "center", width: "80%" }}
        />
      </li>
      <li className="list-group-item">
        <button type="button" className="btn btn-warning">
          Ara
        </button>
      </li>
    </ol>
  );
}

export default PointRange